<template>
  <el-card class="box-card">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="`${$t('ltlorder.list.allOrders')}(${count.all_count})`" name="0">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 0" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.pendingApproval')}(${count.check_pending})`" name="1">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 1" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.approvalRejected')}(${count.approval_rejection})`" name="2">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 2" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.toBePicked')}(${count.to_be_picked})`" name="3">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 3" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.inTransit')}(${count.in_transit_up})`" name="4">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 4" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.delivered')}(${count.delivered})`" name="5">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 5" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.orderCancelled')}(${count.cancelled})`" name="6">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 6" />
      </el-tab-pane>
      <el-tab-pane :label="`${$t('ltlorder.list.refused')}(${count.reject})`" name="7">
        <OrderList @changelist="changelist" :activeName="activeName" v-if="activeName == 7" />
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import OrderList from "./components/orderList.vue";
export default {
  components: {
    OrderList,
  },
  data() {
    return {
      activeName: "0",
      count: {
        all_count: 0,
        approval_rejection: 0,
        cancelled: 0,
        check_pending: 0,
        delivered: 0,
        in_transit_up: 0,
        reject: 0,
        to_be_picked: 0,
      },
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    changelist(type, num) {
      if (type == '数量') {
        this.count = num
      } else {
        this.activeName = num;
      }
    },
  },
};
</script>